<template>
  <div
    class="modal fade"
    id="manufacturerInfoMModal"
    tabindex="-1"
    aria-labelledby="manufacturerInfoMModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              제조사 정보 수정하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalPartTitle">제조사 정보 수정</div>
            <div class="modalInputDiv">
              <label for="">사업자등록번호<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록 번호를 입력해주세요(ex. 123-45-67890)"
                v-model="businessNumber"
                @input="changeBusinessNumber"
                maxlength="12"
                @keyup.enter="businessNumberValidate"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="businessNumberValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label/>
              <span class="businessNumberMsgM fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <button 
                class="btn btn-primary"
                @click="openBusinessFileInput()"
                style="margin-bottom: 0!important;"
              >등록증 업로드</button>
              <span 
              class="imgspan hoverPointer" 
              style="margin-left: 10px; width: 40%; overflow: hidden; "
              @click="downloadBusinessNumImage()"
              >{{ businessFileName }}</span>
              <input
              type="file"
              id="businessFileInputM"
              ref="businessFileInputM"
              @change="changeBusinessNumImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label>테스트 제조사 여부</label>
              <div class="radioWrap">
                <div class="radioObj">
                  <a-checkbox
                    v-model:checked="isTestCompany"
                    id="isTestCompanyW"
                  />
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label for="">진료 과목<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj" v-for="(item, i) in deptList" :key="i">
                  <input 
                  type="checkbox" 
                  :value="item.code"
                  :id="item.code+'M'"
                  v-model="medicalDept"
                  /> 
                  <label :for="item.code+'M'">{{ item.name }}</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">제조사명<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록증에 등록된 업체명을 입력하세요."
                v-model="manufacturerName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">지역 구분<span class="requiredSpan">*</span></label>
              <select v-model="selectedAreaFirst" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                height: 35px;" id="itemCode"
                @change="areaSecondChange()"
              >
                <option value="" selected>시/도 선택</option>
                <option v-for="item in areaFirst" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaSecond" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
                @change="areaThirdChange()"
              >
                <option value="" selected>시/군/구 선택</option>
                <option v-for="item in areaSecond" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaThird" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
              >
                <option value="" selected>읍/면/동 선택</option>
                <option v-for="item in areaThird" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label for="">상세 주소</label>
              <input
                type="text"
                placeholder="나머지 상세주소를 입력하세요."
                v-model="addrDetail"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">대표 전화번호<span class="requiredSpan">*</span></label>
              <input
              type="text"
              placeholder="대표 전화번호를 입력해주세요(ex. 02-1234-5678)."
              v-model="manufacturerPhoneNumber"
              maxlength="13"
              @input="changeManufacturerPhoneNumber"
              />
              <div class="modalInputRight"/>
            </div>
            <div style="height: 30px;"/>
            
           
            <div class="modalInputDiv" style="padding: 0!important">
              <label for=""/>
              <span class="businessNumberMsgM fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">페이지 로고<span class="requiredSpan">*</span></label>
              <button 
                class="btn btn-primary"
                @click="openLogoFileInput()"
                style="margin-bottom: 0!important;"
              >이미지 업로드</button>
              <input
              type="file"
              id="logoFileInputM"
              accept="image/jpeg, image/png"
              ref="logoFileInputM"
              @change="changeLogoImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div>
                <span class="imgspan"
                > 
                <img src="#" alt="" id="logoPrevM" class="hoverPointer" @click="downloadLogoImage()" />
                </span>
                <div>
                  <span 
                  class="imgspan hoverPointer"
                  @click="downloadLogoImage()"
                  >{{logoFileName}}</span>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div class="modalTextSmall">
                이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
              </div>
            </div>
            <section
              v-if="!isDentalLaboratory"
              data-testid="manufacturer-favicon"
              class="modalDivWrap"
              aria-labelledby="manufacturerFaviconTitleM"
            >
              <div id="manufacturerFaviconTitleM" class="modalPartTitle">
                브라우저 favicon
              </div>
              <div class="modalInputDiv">
                <label for="manufacturerFaviconInputM">favicon 이미지</label>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="faviconUploading"
                  @click="openFaviconFileInput"
                >
                  PNG 선택
                </button>
                <input
                  id="manufacturerFaviconInputM"
                  ref="faviconFileInputM"
                  type="file"
                  accept="image/png"
                  :disabled="faviconUploading"
                  @change="changeFaviconImage"
                />
              </div>
              <div
                v-if="(faviconPreviewUrl || faviconUrl) && faviconIntent !== 'delete'"
                class="modalInputDiv"
              >
                <label>현재 미리보기</label>
                <img
                  :src="faviconPreviewUrl || faviconUrl"
                  width="48"
                  height="48"
                  alt="제조사 favicon 미리보기"
                  style="object-fit: contain"
                />
                <span
                  v-if="faviconFile"
                  class="modalTextSmall"
                  style="margin-left: 10px"
                >
                  {{ faviconFile.name }}
                </span>
              </div>
              <div class="modalInputDiv">
                <label />
                <div class="modalTextSmall">
                  PNG · 정사각형 · 16~512px · 최대 1MiB. 아래 수정하기를 누르면
                  일반 정보 저장 후 favicon 변경을 적용합니다.
                </div>
              </div>
              <div class="modalInputDiv">
                <label />
                <div>
                  <button
                    v-if="faviconIntent !== 'delete'"
                    type="button"
                    class="btn btn-secondary"
                    :disabled="!serverFaviconUrl || faviconUploading"
                    @click="selectFaviconDeletion"
                  >
                    삭제
                  </button>
                  <button
                    v-if="faviconIntent !== 'keep'"
                    type="button"
                    class="btn btn-secondary"
                    :disabled="faviconUploading"
                    style="margin-left: 10px"
                    @click="resetFaviconIntent"
                  >
                    변경 취소
                  </button>
                  <button
                    v-if="faviconStatus === 'error' && lastFaviconAction && generalInfoSaved"
                    type="button"
                    class="btn btn-primary"
                    :disabled="faviconUploading"
                    style="margin-left: 10px"
                    @click="retryFaviconAction"
                  >
                    다시 시도
                  </button>
                </div>
              </div>
              <div class="modalInputDiv">
                <label />
                <div aria-live="polite" role="status">
                  <span :class="faviconStatus === 'error' ? 'fail' : 'success'">
                    {{ faviconStatusMessage }}
                  </span>
                </div>
              </div>
            </section>
            
          </div>
          <div class="modalDivWrap">
            <div class="modalPartTitle">관리자 정보 수정</div>
            <div class="modalInputDiv"/>
            <div class="modalInputDiv">
              <label for="">관리자 이름<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="해당 제조사의 관리자 이름을 입력해주세요."
                v-model="managerName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">관리자 직급</label>
              <input
                type="text"
                placeholder="관리자의 직급을 입력해주세요."
                v-model="managerDuty"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">관리자 연락처<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="관리자의 연락처를 입력해주세요."
                v-model="managerPhoneNumber"
                maxlength="13"
                @input="changeManagerPhoneNumber"
              />
              <div class="modalInputRight"/>
            </div>
            <input
            type="text"
            style="width:0px !important; height: 0px !important; display: none;"
          />
            <input
            type="password"
            style="width:0px !important; height: 0px !important; display: none;"
            />
            <div class="modalInputDiv">
              <label for="">관리자 이메일</label>
              <span style="color: black;">{{ managerId }}</span>
              <div class="modalInputRight"/>
            </div>
          </div>
        </div>
        <!-- 운영자 회사 강제 스위치(C8, REQ-ACC-012) -->
        <div class="px-4">
          <company-two-factor-policy-switch :company-id="manufacturerId" />
          <!-- 고객 지원을 위한 접근(동의 스위치·지원 계정·지원 접속 — W6 A3) -->
          <support-access-card :company-id="manufacturerId" :company-type="type" :company-name="manufacturerName" />
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :disabled="faviconUploading"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            :disabled="faviconUploading"
            @click="modifyManufacturer()"
          >
            {{ faviconUploading ? "favicon 처리 중..." : "수정하기" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyTwoFactorPolicySwitch from "@/views/components/CompanyTwoFactorPolicySwitch.vue";
import SupportAccessCard from "@/views/components/SupportAccessCard.vue";
import {
  YnEnum
} from '@/enums/common.enums';
import jsonFile from "../../assets/locations.json";
import { businessNumberFormatter, changeBytesToKilos, confirmDialog, decodeUtfText, openDialog, phoneNumberFormatter } from "../../utils/utils";
import {
  deleteManufacturerFavicon,
  getManufacturerFaviconUrl,
  uploadManufacturerFavicon,
  validateManufacturerFaviconFile,
} from "@/views/ManufacturerManagement/api";
import {
  finalizePreviewBeforeReload,
  retryManufacturerFaviconMutation,
  runManufacturerFaviconUpdate,
} from "@/views/ManufacturerManagement/favicon-workflow.mjs";

export default {
  components: { CompanyTwoFactorPolicySwitch, SupportAccessCard },
  data() {
    return {
      manufacturerId: "", // 제조사Id

      deptList: [], // 제조사 구분
      manufacturerName: "", // 업체명
      manufacturerPhoneNumber: "", // 대표 전화번호
      businessNumber: "", // 사업자등록번호
      originalBusinessNumber: '', // 사업자등록번호
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      addrDetail: "", // 주소 상세
      medicalDept: [], // 선택된 제조사구분


      managerName: "", // 관리자 이름
      managerDuty: "", // 관리자 직급
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
      password: "", // 관리자 비밀번호
      passwordConfirm: "", // 비밀번호 확인

      businessFileName: "", // 사업자이미지 파일명
      businessFileData: null, // 실제 사업자이미지파일 정보가 담긴 폼데이터
      businessImgUrl: "", // objectStorage 상 사업자이미지 url

      logoFileName: "", // 로고이미지 파일명
      logoFileData: null, // 실제 로고파일 정보가 담긴 폼데이터
      logoImgUrl: "", // objectStorage 상 로고이미지 url

      faviconUrl: "",
      serverFaviconUrl: "",
      faviconFile: null,
      faviconPreviewUrl: "",
      faviconIntent: "keep",
      faviconStatus: "idle",
      faviconError: "",
      faviconUploading: false,
      lastFaviconAction: "",
      generalInfoSaved: false,

      // 검증관련 불리언, 필수값에 따라 추가 -> 최초에 등록됐던 값은 유효한 것으로 판단
      isBusinessNumberValid: true,
      isTestCompany: false, // 테스트 제조사 여부
    };
  },
  props: {
    isDentalLaboratory: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    type() {
      return this.isDentalLaboratory ? "DENTAL_LABORATORY" : "MANUFACTURER";
    },
    faviconStatusMessage() {
      if (this.faviconStatus === "selected" && this.faviconIntent === "replace") {
        return "수정 시 업로드할 PNG가 선택되었습니다.";
      }
      if (this.faviconStatus === "selected" && this.faviconIntent === "delete") {
        return "수정 시 등록된 favicon을 삭제합니다.";
      }
      if (this.faviconStatus === "uploading") return "favicon 작업을 처리하고 있습니다.";
      if (this.faviconStatus === "success") return "favicon 작업이 완료되었습니다.";
      if (this.faviconStatus === "error") return this.faviconError;
      return this.faviconUrl
        ? "등록된 favicon이 있습니다."
        : "등록된 favicon이 없습니다.";
    },
  },
  async mounted() {
    this.initValues();
    this.getAreaList();
    await this.getDeptList();
    this.$el.addEventListener("hidden.bs.modal", this.handleFaviconModalClosed);
  },
  beforeUnmount() {
    this.$el.removeEventListener("hidden.bs.modal", this.handleFaviconModalClosed);
    this.releaseFaviconPreview();
  },
  watch: {
    isDentalLaboratory(isDentalLaboratory) {
      if (isDentalLaboratory) {
        this.releaseFaviconPreview();
        this.faviconUrl = "";
        this.serverFaviconUrl = "";
        this.faviconFile = null;
        this.faviconIntent = "keep";
        this.faviconStatus = "idle";
        this.faviconError = "";
        this.lastFaviconAction = "";
        this.generalInfoSaved = false;
      }
    },
    data: {
      immediate: true,
      deep: true, 
      async handler(newValue, oldValue) {
        if(newValue && newValue.manufacturerId !== this.manufacturerId) {
          this.initValues();
          this.getAreaList();
          await this.getDeptList();

          if(newValue.addrOne) this.selectedAreaFirst = newValue.addrOne;
          this.areaSecondChange();
          if(newValue.addrTwo) this.selectedAreaSecond = newValue.addrTwo;
          this.areaThirdChange();
          if(newValue.addrThree) this.selectedAreaThird = newValue.addrThree;
          if(newValue.addrDetail) {
            this.addrDetail = newValue.addrDetail;
          } else {
            this.addrDetail = '';
          }
          if(newValue.isTestCompany) this.isTestCompany = newValue.isTestCompany;
          if(newValue.medicalDept) this.medicalDept = newValue.medicalDept;

          if(newValue.cNo) this.businessNumber = newValue.cNo;
          if(newValue.cNo) this.originalBusinessNumber = newValue.cNo;
          if(newValue.cNoUrl) {
            this.businessImgUrl = newValue.cNoUrl;
            const businessUrlArray = newValue.cNoUrl.split("/");
            this.businessFileName = decodeUtfText(businessUrlArray[businessUrlArray.length - 1]);
          } 
          this.changeBusinessNumber();
          this.isBusinessNumberValid = true;
          if(newValue.call) this.manufacturerPhoneNumber = newValue.call;
          this.changeManufacturerPhoneNumber();
          if(newValue.imgUrl) {
            this.logoImgUrl = newValue.imgUrl;
            const logoUrlArray = newValue.imgUrl.split("/");
            this.logoFileName = decodeUtfText(logoUrlArray[logoUrlArray.length - 1]);
          }
          if(newValue.manufacturerId) this.manufacturerId = newValue.manufacturerId;
          if(newValue.name) this.manufacturerName = newValue.name;
          if (!this.isDentalLaboratory) {
            this.serverFaviconUrl = newValue.faviconUrl || "";
            this.faviconUrl = this.serverFaviconUrl;
          }

          if(newValue.accountInfo && newValue.accountInfo.mobile) {
            this.managerPhoneNumber = newValue.accountInfo.mobile;
            this.changeManagerPhoneNumber();
          }
          if(newValue.accountInfo && newValue.accountInfo.name) this.managerName = newValue.accountInfo.name;
          if(newValue.accountInfo && newValue.accountInfo.duty) this.managerDuty = newValue.accountInfo.duty;
          if(newValue.accountInfo && newValue.accountInfo.username) this.managerId = newValue.accountInfo.username;
        }
        if(document.getElementById("logoPrevM")) document.getElementById("logoPrevM").src = this.logoImgUrl;
      }
    }
  },
  methods: {
    releaseFaviconPreview() {
      if (this.faviconPreviewUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(this.faviconPreviewUrl);
      }
      this.faviconPreviewUrl = "";
    },
    reloadAfterFaviconPreviewCleanup() {
      finalizePreviewBeforeReload({
        previewUrl: this.faviconPreviewUrl,
        revokeObjectUrl: (url) => URL.revokeObjectURL(url),
        setPreviewUrl: (url) => {
          this.faviconPreviewUrl = url;
        },
        reload: () => location.reload(),
      });
    },
    resetFaviconIntent() {
      if (this.isDentalLaboratory) return;
      this.releaseFaviconPreview();
      this.faviconUrl = this.serverFaviconUrl;
      this.faviconFile = null;
      this.faviconIntent = "keep";
      this.faviconStatus = "idle";
      this.faviconError = "";
      this.lastFaviconAction = "";
      if (this.$refs.faviconFileInputM) this.$refs.faviconFileInputM.value = "";
    },
    handleFaviconModalClosed() {
      if (this.isDentalLaboratory) return;
      this.generalInfoSaved = false;
      this.resetFaviconIntent();
    },
    openFaviconFileInput() {
      if (this.isDentalLaboratory) return;
      this.$refs.faviconFileInputM?.click();
    },
    changeFaviconImage(event) {
      if (this.isDentalLaboratory) return;
      const file = event.target.files?.[0];
      const validationError = validateManufacturerFaviconFile(file);

      this.releaseFaviconPreview();
      this.faviconFile = null;
      this.faviconError = validationError;
      this.faviconStatus = validationError ? "error" : "selected";
      this.lastFaviconAction = validationError ? "" : "upload";

      if (validationError) {
        event.target.value = "";
        return;
      }

      this.faviconFile = file;
      this.faviconIntent = "replace";
      this.faviconPreviewUrl = URL.createObjectURL(file);
    },
    async uploadFavicon() {
      if (this.isDentalLaboratory) return;
      if (!this.manufacturerId || !this.faviconFile || this.faviconUploading) return false;

      this.lastFaviconAction = "upload";
      this.faviconStatus = "uploading";
      this.faviconError = "";
      this.faviconUploading = true;
      try {
        const result = await retryManufacturerFaviconMutation({
          intent: "replace",
          manufacturerId: this.manufacturerId,
          file: this.faviconFile,
          upload: uploadManufacturerFavicon,
        });
        if (!result.faviconApplied) {
          this.faviconStatus = "error";
          this.faviconError = `제조사 정보는 수정되었으나 favicon 업로드에 실패했습니다${
            result.errorCode ? ` (${result.errorCode})` : ""
          }. 다시 시도해 주세요.`;
          return false;
        }

        const nextUrl = getManufacturerFaviconUrl(result.payload);
        this.releaseFaviconPreview();
        this.serverFaviconUrl = nextUrl;
        this.faviconUrl = nextUrl;
        this.faviconFile = null;
        this.faviconIntent = "keep";
        this.faviconStatus = "success";
        this.lastFaviconAction = "";
        if (this.$refs.faviconFileInputM) this.$refs.faviconFileInputM.value = "";
        return true;
      } finally {
        this.faviconUploading = false;
      }
    },
    async selectFaviconDeletion() {
      if (this.isDentalLaboratory) return;
      if (!this.serverFaviconUrl || this.faviconUploading) return;

      const confirmed = await confirmDialog(
        "favicon 삭제",
        "수정하기를 누르면 등록된 제조사 favicon을 삭제합니다.",
      );
      if (!confirmed) return;

      this.releaseFaviconPreview();
      this.faviconFile = null;
      this.faviconIntent = "delete";
      this.faviconStatus = "selected";
      this.faviconError = "";
      this.lastFaviconAction = "delete";
      if (this.$refs.faviconFileInputM) this.$refs.faviconFileInputM.value = "";
    },
    async performDeleteFavicon() {
      if (this.isDentalLaboratory) return;
      if (!this.manufacturerId || !this.serverFaviconUrl || this.faviconUploading) {
        return false;
      }

      this.lastFaviconAction = "delete";
      this.faviconStatus = "uploading";
      this.faviconError = "";
      this.faviconUploading = true;
      try {
        const result = await retryManufacturerFaviconMutation({
          intent: "delete",
          manufacturerId: this.manufacturerId,
          remove: deleteManufacturerFavicon,
        });
        if (!result.faviconApplied) {
          this.faviconStatus = "error";
          this.faviconError = `제조사 정보는 수정되었으나 favicon 삭제에 실패했습니다${
            result.errorCode ? ` (${result.errorCode})` : ""
          }. 다시 시도해 주세요.`;
          return false;
        }

        this.releaseFaviconPreview();
        this.serverFaviconUrl = "";
        this.faviconUrl = "";
        this.faviconFile = null;
        this.faviconIntent = "keep";
        this.faviconStatus = "success";
        this.lastFaviconAction = "";
        if (this.$refs.faviconFileInputM) this.$refs.faviconFileInputM.value = "";
        return true;
      } finally {
        this.faviconUploading = false;
      }
    },
    async retryFaviconAction() {
      if (this.isDentalLaboratory) return;
      let succeeded = false;
      if (this.lastFaviconAction === "upload") succeeded = await this.uploadFavicon();
      if (this.lastFaviconAction === "delete") {
        succeeded = await this.performDeleteFavicon();
      }
      if (succeeded && this.generalInfoSaved) {
        await openDialog("제조사 정보와 favicon 수정이 완료되었습니다.", "success", "확인").then(
          () => this.reloadAfterFaviconPreviewCleanup(),
        );
      }
    },
    
    changeManufacturerPhoneNumber() {
      this.manufacturerPhoneNumber = phoneNumberFormatter(this.manufacturerPhoneNumber.toString());
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },
    // 주요 API

    // 제조사 정보 수정
    async modifyManufacturer() {
      if(await this.validateData()) {
        try {
          const obj = {};
          if(this.businessFileData) {
            const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
            obj.cNoUrl = businessImgUrl; 
          } else {
            obj.cNoUrl = this.businessImgUrl;
          }
          if(this.logoFileData) {
            const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
            obj.imgUrl = logoImgUrl; 
          } else {
            obj.imgUrl = this.logoImgUrl;
          }
          const deptArr = new Array();
          this.medicalDept.forEach((ele) => {
            deptArr.push(ele);
          });
          obj.medicalDept = deptArr;       

          obj.name = this.manufacturerName;
          obj.cNo = this.businessNumber.replace(/-/g, '');
          obj.addrOne = this.selectedAreaFirst;
          obj.addrTwo = this.selectedAreaSecond;
          obj.addrThree = this.selectedAreaThird;
          obj.addrDetail = this.addrDetail || '';
          obj.isTestCompany = this.isTestCompany ? YnEnum.Y : YnEnum.N;

          if(this.manufacturerPhoneNumber) {
            obj.call = this.manufacturerPhoneNumber.replace(/-/g, '');
          } else {
            obj.call = '';
          };
          obj.type = this.type;

          const accountInfo = {};
          accountInfo.name = this.managerName;
          if(this.managerDuty){
            accountInfo.duty = this.managerDuty;
          } else {
            accountInfo.duty = '';
          } 
          if(this.managerPhoneNumber) accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, "");
          obj.accountInfo = accountInfo;

          const requestedFaviconIntent = this.isDentalLaboratory
            ? "keep"
            : this.faviconIntent;
          if (requestedFaviconIntent !== "keep") {
            this.faviconStatus = "uploading";
            this.faviconError = "";
            this.faviconUploading = true;
          }

          const updateResult = await runManufacturerFaviconUpdate({
            saveCompany: () =>
              this.$apiInstance.put(`/companies/${this.manufacturerId}`, obj),
            intent: requestedFaviconIntent,
            manufacturerId: this.manufacturerId,
            file: this.faviconFile,
            upload: uploadManufacturerFavicon,
            remove: deleteManufacturerFavicon,
            isDentalLaboratory: this.isDentalLaboratory,
          });
          this.faviconUploading = false;

          if (!updateResult.companySaved) {
            if (updateResult.error) throw updateResult.error;
            await openDialog("제조사 정보 수정에 실패하였습니다.", "error", "확인");
            return;
          }

          this.generalInfoSaved = true;

          if (!updateResult.faviconApplied) {
            this.lastFaviconAction =
              updateResult.action === "replace" ? "upload" : "delete";
            this.faviconStatus = "error";
            this.faviconError =
              `제조사 정보는 수정되었으나 favicon ${
                updateResult.action === "replace" ? "업로드" : "삭제"
              }에 실패했습니다${
                updateResult.errorCode ? ` (${updateResult.errorCode})` : ""
              }. 다시 시도해 주세요.`;
            await openDialog(this.faviconError, "error", "확인");
            return;
          }

          if (updateResult.action === "replace") {
            const nextUrl = getManufacturerFaviconUrl(updateResult.payload);
            this.releaseFaviconPreview();
            this.serverFaviconUrl = nextUrl;
            this.faviconUrl = nextUrl;
          }
          if (updateResult.action === "delete") {
            this.releaseFaviconPreview();
            this.serverFaviconUrl = "";
            this.faviconUrl = "";
          }
          this.faviconFile = null;
          this.faviconIntent = "keep";
          this.lastFaviconAction = "";
          if (updateResult.mutationAttempted) this.faviconStatus = "success";

          await openDialog("제조사 정보 수정이 완료되었습니다.","success", "확인")
          .then(() => {
            this.reloadAfterFaviconPreviewCleanup();
          });

        } catch (error) {
          this.faviconUploading = false;
          console.log(error);
          if(error.response && error.response.status === 400) {
            await openDialog("이미 존재하는 계정입니다.", "error", "확인");
          }
        }
      }
    },
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if(response.status === 200 || response.status === 201) {
          this.deptList = response.data;
        }
      } catch(error) {
        console.log(error);
      }
    },
    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return "";
      }
    },

    // 사업자등록번호 validate
    async businessNumberValidate() {
      const trimmedBusinessNumber = this.businessNumber.replace(/-/g, '');
      const businessNumberMsg = document.querySelector(".businessNumberMsgM");
      if (this.businessNumber.replaceAll('-','').length < 10) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
          businessNumberMsg.innerHTML = "잘못된 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
      } else {
        const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${trimmedBusinessNumber}`);
        if(response && (response.status === 200 || response.status === 201) && !response.data) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else if (this.originalBusinessNumber.replace(/-/g, '') === trimmedBusinessNumber) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
          businessNumberMsg.innerHTML = "이미 존재하는 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
        }
      }
    },

    // 파일첨부 창이 잘 안떠서 별도로 만든 클릭 메소드
    openBusinessFileInput() {
      this.$refs.businessFileInputM.click();
    },

    openLogoFileInput() {
      this.$refs.logoFileInputM.click();
    },

    // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert('png, jpeg, jpg 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    validateFileSize(file) {
      let result = true;
      if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },


    // 사업자등록증 이미지 onChange메소드
    changeBusinessNumImage() {
      const fileInput = document.getElementById("businessFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if(validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.businessFileData = formData;
        }
      } else {
      }
    },

    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      const fileInput = document.getElementById("logoFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("logoPrevM").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;
          document.getElementById("logoPrevM").classList.remove("hide");

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.logoFileData = formData;
        };
      } else {
        document.getElementById("logoPrevM").src = "";
      }
    },

    // 사업자등록증 다운로드
    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.businessImgUrl;
        downloadLink.download = this.businessFileName; 
        downloadLink.click();
      }
    },

    // 로고 이미지 다운로드
    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.logoImgUrl;
        downloadLink.download = this.logoFileName; 
        downloadLink.click();
      }
    },

    // 업로드 전 검증
    async validateData() {
      let result = true;
      if (!this.manufacturerName) {
        await openDialog("제조사 이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if (this.medicalDept.length === 0) {
        await openDialog("진료 과목을 선택해 주세요.", "error", "확인");
        result = false;
      } else if( !this.selectedAreaFirst ||
        !this.selectedAreaSecond ||
        !this.selectedAreaThird) {
        await openDialog("제조사 지역을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.manufacturerPhoneNumber) {
        await openDialog("제조사 대표 전화번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.businessNumber) {
        await openDialog("사업자등록번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if (this.businessNumber.replaceAll('-','').length < 10) {
        await openDialog("사업자등록번호를 올바르게 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerName) {
        await openDialog("관리자 이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerPhoneNumber) {
        await openDialog("관리자 연락처를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.managerId) {
        await openDialog("관리자 이메일 주소를 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.isBusinessNumberValid) {
        await openDialog("사업자등록번호 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } 
      return result;
    },

      
    // 기타 manuInfoM용 utils

    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) => a.localeCompare(b, 'ko-KR'));
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if(this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        if(secondLevelData) {
          this.areaSecond = Object.keys(secondLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaThird = [];
        } else {
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaSecond = [];
          this.areaThird = [];
        }
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
    },
    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        if(!jsonFile[this.selectedAreaFirst]) {
          this.selectedAreaThird = '';
          this.areaThird = [];
          return;
        }
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
          if(thirdLevelData) {
            this.areaThird = Object.keys(thirdLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
            this.selectedAreaThird = '';
          } else {
            this.selectedAreaThird = '';
            this.areaThird = [];
          }
      } else {
        this.selectedAreaThird = '';
        this.areaThird = [];
      }
    },

    // 항목 초기화 용도
    initValues() {
      this.manufacturerName = "";
      this.manufacturerPhoneNumber = "";
      this.businessNumber = "";
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.logoImgUrl = "";
      this.businessImgUrl = "";
      this.logoFileData = null;
      this.businessFileData = null;
      this.releaseFaviconPreview();
      this.faviconUrl = "";
      this.serverFaviconUrl = "";
      this.faviconFile = null;
      this.faviconIntent = "keep";
      this.faviconStatus = "idle";
      this.faviconError = "";
      this.faviconUploading = false;
      this.lastFaviconAction = "";
      this.generalInfoSaved = false;
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
      this.addrDetail = "";

      let bFileInput;
      if(document.getElementById("businessFileInputM")) {
        bFileInput = document.getElementById("businessFileInputM").value;
        if (!bFileInput.length || bFileInput === "") {
          this.businessFileName = "";
        }
      }

      let lFileInput;
      if(document.getElementById("logoFileInputM")) {
      lFileInput = document.getElementById("logoFileInputM").value;
      if (!lFileInput.length || lFileInput === "") {
        this.logoFileName = "";
      }
      }

      if(document.getElementById("logoPrevM")) document.getElementById("logoPrevM").src = "";
      if(document.querySelector(".businessNumberMsgM")) document.querySelector(".businessNumberMsgM").innerHTML = "";
    },

    // 사업자등록번호(중복확인 필요한 값)의 값 변경 시 valid false로 재설정
    changeBusinessNumber() {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if(document.querySelector(".businessNumberMsgM")) document.querySelector(".businessNumberMsgM").innerHTML = "";
    },
  },
};
</script>
